import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import apiClient from '@/lib/api/client'
import { tenantRegister } from '@/lib/api/generated/sdk.gen'

export const useRegisterTenant = () => {
  const navigate = useNavigate()
  return useMutation({
    // data: { account: string; password: string; tenantName?: string; contactName?: string }
    mutationFn: async (data: { account: string; password: string; tenantName?: string; contactName?: string }): Promise<any> => {
      const res: any = await tenantRegister({
        client: apiClient,
        body: data as any,
        responseStyle: 'fields',
        throwOnError: true,
      })
      return (res as any)?.data ?? res
    },
    onSuccess: (data: any) => {
      const token = data?.accessToken || data?.token
      if (token) localStorage.setItem('tenant_token', token)
      // 不自动跳转，让用户在页面内主动开始 Onboarding
    },
    onError: () => {}
  })
}


